module.exports = __webpack_public_path__ + "static/media/banner_m_05.13c4e0b9.jpg";